import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { useContext, useState } from "react";
import {
	changeLoadingOrganisasi,
	changeOrganisasi,
} from "../../context/actions";
import { OrganisasiCtx } from "../../context/context";
import { getOrganisasi, RESET_STATE_ORGANISASI } from "../helpers";

function useReloadTableOrganisasi() {
	const { state, dispatch } = useContext(OrganisasiCtx);

	const [formFilter, setFormFilter] = useState(RESET_STATE_ORGANISASI);
	const handleChange = (text) => (e) => {
		setFormFilter({
			...formFilter,
			[text]: e.target.value,
		});
	};

	const setNewData = async (
		pages = formFilter.pages,
		limit = formFilter.limit,
		formSearch = formFilter
	) => {
		dispatch(changeLoadingOrganisasi(true));
		const response = await getOrganisasi(formSearch, pages, limit);
		if (response.state) {
			dispatch(
				changeOrganisasi({
					status: response.status,
					message: response.message,
					body: response.body,
					count: response.count,
					sisa: response.sisa,
					limit: response.limit,
					pages: response.pages,
				})
			);
			dispatch(changeLoadingOrganisasi(false));
			// defaultToastSuccess(response.message);
		} else {
			dispatch(
				changeOrganisasi({
					status: "",
					message: "",
					body: [],
					count: 1,
					sisa: true,
					limit: 10,
					pages: 1,
				})
			);
			dispatch(changeLoadingOrganisasi(false));
			defaultToastError(response.message);
		}
	};

	const {
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	} = useDatatablesServerSide({
		setNewData: setNewData,
		additionalProps: formFilter,
	});

	return {
		setNewData,
		loading: state.loadingOrganisasi,
		handleChange,
		formFilter,
		setFormFilter,
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	};
}

export default useReloadTableOrganisasi;
